import { BaseDrawOption } from '@/modules/ta/widget/models/drawoptions/BaseDrawOption';

export class GoalDrawOption extends BaseDrawOption {}
